import { Page } from '../../../../components/page/page';
import { ReviewCards } from './review-cards/review-cards';
import { ReviewsControls } from './reviews-controls/reviews-controls';
import { ReviewsMarks } from './reviews-marks/reviews-marks';
import { ReviewsTable } from './reviews-table/reviews-table';
import s from './reviews.module.css';
import { useReviews } from './use-reviews';

export const Reviews = () => {
  const { t, viewStyle, handleEnd, pagination, handleExport, title } = useReviews();

  return (
    <Page className={s.page}>
      <div className={s.header}>
        <h2>
          {t(title)} ({pagination?.count})
        </h2>
        <ReviewsControls onExport={handleExport} />
      </div>

      <ReviewsMarks />

      {viewStyle === 'table' ? <ReviewsTable key={title} /> : <ReviewCards onEnd={handleEnd} />}
    </Page>
  );
};
